import gql from 'graphql-tag'

export const GET_ASSIGNMENTS = gql`
  query($startISO: String!, $endISO: String!) {
    getAssignments(startISO: $startISO, endISO: $endISO) {
      _id
      projectId
      startDate
      endDate
      type
      percent
      investment
      approveState {
        status
        comment
        requester
        request {
          percent
          startDate
          endDate
          comment
        }
      }
    }
  }
`

export const GET_ASSIGNMENTS_AS_DELEGATE = gql`
  query($startISO: String!, $endISO: String!, $delegateId: String!) {
    getAssignments_asDelegate(startISO: $startISO, endISO: $endISO, delegateId: $delegateId) {
      _id
      projectId
      startDate
      endDate
      type
      percent
      investment
      approveState {
        status
        comment
        requester
        request {
          percent
          startDate
          endDate
          comment
        }
      }
    }
  }
`

export const GET_ASSIGNMENTS_BY_PROJECTS = gql`
  query($projectIds: String!, $startISO: String!, $endISO: String!) {
    getAssignmentsByProjects(projectIds: $projectIds, startISO: $startISO, endISO: $endISO) {
      _id
      projectId
      personId
      startDate
      endDate
      type
      percent
      investment
      approveState {
        status
        comment
        requester
        request {
          percent
          startDate
          endDate
          comment
        }
      }
    }
  }
`

export const DELETE_ASSIGNMENT = gql`
  mutation($_id: String!) {
    deleteAssignment(_id: $_id)
  }
`

export const CREATE_ASSIGNMENT = gql`
  mutation(
    $projectId: String!
    $personId: String!
    $startDate: String!
    $endDate: String!
    $percent: String!
    $investment: String!
  ) {
    createAssignment(
      projectId: $projectId
      personId: $personId
      startDate: $startDate
      endDate: $endDate
      percent: $percent
      investment: $investment
    ) {
      _id
      projectId
      personId
      startDate
      endDate
      type
      percent
      investment
      approveState {
        status
        comment
        requester
        request {
          percent
          startDate
          endDate
          comment
        }
      }
    }
  }
`

export const UPDATE_ASSIGNMENT = gql`
  mutation(
    $_id: String!
    $projectId: String!
    $personId: String!
    $startDate: String!
    $endDate: String!
    $percent: String!
    $investment: String!
  ) {
    updateAssignment(
      _id: $_id
      projectId: $projectId
      personId: $personId
      startDate: $startDate
      endDate: $endDate
      percent: $percent
      investment: $investment
    ) {
      _id
      projectId
      personId
      startDate
      endDate
      type
      percent
      investment
      approveState {
        status
        comment
        requester
        request {
          percent
          startDate
          endDate
          comment
        }
      }
    }
  }
`

export const ADJUST_ASSIGNMENT = gql`
  mutation(
    $assignmentId: String!
    $status: String!
    $comment: String!
    $requester: String!
    $percent: String!
    $startDate: String!
    $endDate: String!
    $leadId: String!
  ) {
    adjustAssignment(
      assignmentId: $assignmentId
      status: $status
      comment: $comment
      requester: $requester
      percent: $percent
      startDate: $startDate
      endDate: $endDate
      leadId: $leadId
    ) {
      _id
      projectId
      personId
      startDate
      endDate
      type
      percent
      investment
      approveState {
        status
        comment
        requester
        request {
          percent
          startDate
          endDate
          comment
        }
      }
    }
  }
`
